import type { Organization } from '#/domain/organization/Organization'
import { isInvalidOrganization } from '#/domain/organization/InvalidOrganization'
import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

// Auth0 caps per_page at 100 — paginate until every organization has been collected.
const PAGE_SIZE = 100

export class FindAllOrganizationsUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(): Promise<Organization[]> {
    const organizations: Organization[] = []
    let fetchedCount = 0
    let page = 1
    while (true) {
      const batch = await this.repository.findAll({ page, itemsPerPage: PAGE_SIZE })
      organizations.push(
        ...batch.items.filter((item): item is Organization => !isInvalidOrganization(item)),
      )
      fetchedCount += batch.items.length
      if (fetchedCount >= batch.total || batch.items.length < PAGE_SIZE) break
      page++
    }
    return organizations
  }
}
